(function ($, undefined) {
    'use strict';

    $(document).on('change', '#is_partial', function(e) {
        if(e.target.checked) {
            $("#partial_form").show("slow");
        } else {
            $("#partial_form").hide("slow");
        }
    });

    $(document).on('shown.bs.modal', '#modal', function(e) {
        $("#partial_form").hide();
        $('#is_partial').prop('checked', false);
        if($("#order_total").val() > $("#maximum_amount_allowed").val()){
            // $("#partial_form").show();
            $("#partial_form").prop('display','block');
            $('#is_partial').prop('checked', true);
            return;
        }

        if($( "#div_maximum_amount_allowed").length > 0){
            $("#partial_form").hide();
        }        
    });

    $(document).on('change', '#amount', function(e) {
        const amount = $("#amount").val();
        const maximum_amount_allowed = $("#maximum_amount_allowed").val();
        if(Number(amount) > Number(maximum_amount_allowed)){
            alert("Error: el monto máximo permitido es de: " + maximum_amount_allowed)
        }
    });
    
})(jQuery);


// WEBPACK FOOTER //
// ./resources/assets/js/generateCreditNote.js